const routes = [
    {
        path: "/reimbursement/request-form",
        component: () => import("../pages/InstructorForm.vue"),
        meta: {
            isAuthenticated: true,
            isStaff: true,
            permission: 'reimbursementform_store',
        },
    },
    {
        path: "/reimbursement/:id",
        component: () => import("../pages/Detail.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'reimbursementform_show',
        },
    },
    {
        path: "/reimbursements",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'reimbursementform_index',
        },
    },
];

export default routes;
